import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../utils/translations';
import {RentalBanner} from './RentalBanner/RentalBanner';
import {RentalNode} from './RentalNode/RentalNode';
import edap from '@homeaway/edap-wrapper';
import {Link} from '@homeaway/react-localization-components';
import {propertyIdSelected} from '../../../utils/edapUtils';

import './RentalInformation.less';

export class RentalInformation extends React.PureComponent {
    static propTypes = {
        listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        actionLocation: PropTypes.string,
        listingUrl: PropTypes.string,
        localGuests: PropTypes.string,
        localizedArrivalTime: PropTypes.string,
        localizedCheckinDate: PropTypes.string.isRequired,
        localizedCheckoutDate: PropTypes.string.isRequired,
        localizedDepartureTime: PropTypes.string,
        reservationReferenceNumber: PropTypes.string.isRequired,
        reservationUuid: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
        tripDetailsUrl: PropTypes.string.isRequired,
    };

    static defaultProps = {
        translations: {},
    };

    onClickViewTripDetails() {
        edap().push({
            name: 'generic.click',
            data: {
                eventaction: 'trip.details.click',
                eventcategory: 'traveler activity',
                eventlabel: 'rental information',
            },
        });
    }

    propertyIdClicked = () => {
        const {actionLocation, listingId, reservationUuid} = this.props;
        propertyIdSelected({actionLocation, listingId, reservationUuid});
    };

    render() {
        const {
            address,
            instantBooking,
            listingId,
            listingOwner,
            listingPhoto,
            listingUrl,
            localGuests,
            localizedArrivalTime,
            localizedCheckinDate,
            localizedCheckoutDate,
            localizedDepartureTime,
            reservationReferenceNumber,
            translations,
            tripDetailsUrl,
        } = this.props;

        return (
            <div className="RentalInformation confirmation-item">
                <RentalBanner
                    address={address}
                    instantBooking={instantBooking}
                    translations={translations}
                    listingPhoto={listingPhoto}
                />
                <h2 className="RentalInformation__title">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.rentalInfo.title'
                    )}
                </h2>
                <div className="RentalInformation__nodes">
                    <RentalNode
                        link={tripDetailsUrl}
                        onClick={this.onClickViewTripDetails}
                        orderXs="1"
                        text={reservationReferenceNumber}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.propertySummary.reservation.id'
                        )}
                    />
                    <RentalNode
                        icon="&rarr;"
                        orderXs="3"
                        text={localizedCheckinDate}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.favorites.add.arrival'
                        )}
                    />
                    <RentalNode
                        orderXs="4"
                        text={localizedCheckoutDate}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.favorites.add.departure'
                        )}
                    />
                    {listingUrl && (
                        <Link href={listingUrl}>
                            {(localizedUrl) => (
                                <RentalNode
                                    orderXs="2"
                                    link={localizedUrl}
                                    text={listingId}
                                    onClick={this.propertyIdClicked}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.inbox.conversation.propertySummary.property.id'
                                    )}
                                />
                            )}
                        </Link>
                    )}
                    <RentalNode
                        orderXs="5"
                        text={localizedArrivalTime}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.bookings.tripSummary.checkin'
                        )}
                    />
                    <RentalNode
                        orderXs="6"
                        text={localizedDepartureTime}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.bookings.tripSummary.checkout'
                        )}
                    />
                    <RentalNode
                        orderXs="7"
                        text={localGuests}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.propertySummary.guests'
                        )}
                    />
                    <RentalNode
                        orderXs="8"
                        text={listingOwner}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.confirmation.manager'
                        )}
                    />
                </div>
            </div>
        );
    }
}
